// src/components/ChatToggle.jsx
import React, { useState } from "react";
import { IconButton, Box } from "@mui/material";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import ChatBox from "./ChatBox";

export default function ChatToggle() {
  const [open, setOpen] = useState(false);
  return (
    <>
      {open && <ChatBox onClose={() => setOpen(false)} />}
      <Box
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 2000,
        }}
      >
        <IconButton
          onClick={() => setOpen(true)}
          aria-label="Abrir chat"
          sx={{
            width: 60,
            height: 60,
            bgcolor: "#e06a00",
            color: "#fff",
            boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
            "&:hover": { bgcolor: "#cc5f00", transform: "scale(1.1)" },
          }}
        >
          <ChatBubbleIcon fontSize="large" />
        </IconButton>
      </Box>
    </>
  );
}
